import { requireStates } from "util";
import Sidebar from "components/support/sidebar";
import Topbar from "components/support/topbar";

const initialStates = [
  {
    name: "app.registration",
    url: "/cadastro",
    abstract: true,
    views: {
      "sidebar@app": Sidebar,
      "topbar@app": Topbar
    },
    data: {
      navigation: {
        priority: 300,
        name: "Cadastros"
      },
      authorization: () => true
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/index.js